/* eslint-disable */
import * as React from 'react';

// material-ui
import { Checkbox, Grid, Chip, IconButton, TableCell, TableRow, Tooltip, Typography, Avatar } from '@mui/material';

// assets
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import EventBusyTwoToneIcon from '@mui/icons-material/EventBusyTwoTone';
import useAuth from 'hooks/useAuth';

import { useNavigate } from 'react-router-dom';
import { roles } from 'store/constant';

function ListingTableRow({ row, index, selected, handleApprove, handleReject }) {
    const { role } = useAuth();
    const navigate = useNavigate();

    return (
        <TableRow
            hover
            role="checkbox"
            aria-checked={selected?.includes(row?.id)}
            tabIndex={-1}
            key={index}
            selected={selected?.includes(row?.id)}
        >
            {/* <TableCell padding="checkbox" sx={{ pl: 3, pr: 2 }} onClick={() => onSelectRow(row?.id)}>
                <Checkbox
                    color="primary"
                    checked={selected?.includes(row?.id)}
                    inputProps={{
                        'aria-labelledby': `enhanced-table-checkbox-${index}`
                    }}
                />
            </TableCell> */}

            <TableCell sx={{ cursor: 'pointer' }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <Avatar src={row?.photo}>{row?.firstName?.charAt(0)?.toUpperCase()}</Avatar>
                    </Grid>
                    <Grid item xs zeroMinWidth>
                        <Typography align="left" variant="subtitle1" component="div">
                            {row?.firstName + ' ' + row?.lastName}
                        </Typography>
                        <Typography align="left" variant="subtitle2" noWrap>
                            {row?.email}
                        </Typography>
                    </Grid>
                </Grid>
            </TableCell>

            <TableCell sx={{ cursor: 'pointer' }}>
                <Grid container alignItems="center">
                    <Typography align="left" variant="subtitle1" component="div">
                        {row?.complexName ? row.complexName : '-'}
                    </Typography>
                </Grid>
            </TableCell>

            <TableCell sx={{ cursor: 'pointer' }}>
                <Grid container alignItems="center">
                    <Typography align="left" variant="subtitle1" component="div">
                        {row?.address && row?.address !== 'address' ? row.address : '-'}
                    </Typography>
                </Grid>
            </TableCell>

            <TableCell sx={{ cursor: 'pointer' }}>
                <Grid container alignItems="center">
                    <Typography align="left" variant="subtitle1" component="div">
                        {row?.company?.phoneNo ?? '--'}
                    </Typography>
                </Grid>
            </TableCell>

            <TableCell sx={{ cursor: 'pointer' }}>
                <Grid container alignItems="center">
                    <Typography
                        sx={{
                            color: `${row?.status === 'APPROVED' ? '#3bc73b' : row?.listingStatus === 'REJECTED' ? '#f73a3a' : '#bfbf02'}`,
                            fontWeight: '900'
                        }}
                        align="left"
                        variant="subtitle1"
                        component="div"
                    >
                        {row?.status}
                    </Typography>
                </Grid>
            </TableCell>

            <TableCell align="center" sx={{ pr: 3 }}>
                {row?.status === 'PENDING' && (role === roles.APARTMENT_MANAGER || role === roles.REGIONAL_MANAGER) && (
                    <Tooltip title={'Approve'}>
                        <IconButton size="large" aria-label="more options" onClick={() => handleApprove(row)}>
                            <FileDownloadDoneIcon color="success" sx={{ fontSize: '1.5rem' }} />
                        </IconButton>
                    </Tooltip>
                )}
                {row?.status === 'PENDING' && (role === roles.APARTMENT_MANAGER || role === roles.REGIONAL_MANAGER) && (
                    <Tooltip title={'Reject'}>
                        <IconButton size="large" aria-label="more options" onClick={() => handleReject(row)}>
                            <EventBusyTwoToneIcon color="error" sx={{ fontSize: '1.5rem' }} />
                        </IconButton>
                    </Tooltip>
                )}
            </TableCell>
        </TableRow>
    );
}

export default ListingTableRow;
